const getLocalBusinessSchema = (
  siteName: string,
  countryCode: string,
  categoryName: string,
  cityDisplayName: string,
  pageUrl: string,
): TMetaLocalBusiness => {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: `${siteName} — ${categoryName} in ${cityDisplayName}`,
    url: pageUrl,
    areaServed: {
      '@type': 'City',
      name: cityDisplayName,
      addressCountry: countryCode,
    },
  };
};

export default getLocalBusinessSchema;
